import { useMatches } from "@tanstack/react-location";
import { LocationGenerics } from "lib/react-location";

export function usedMatchedRouteConfig() {
  const matches = useMatches<LocationGenerics>();
  return matches[matches.length - 1].route;
}
